import { Injector } from '@angular/core';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import {
  ActionButtonOutcomesType,
  BaseWidgetProperties,
  ButtonActionType,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { take } from 'rxjs';
import { PispCancelRecurringPayment } from '../../../actions/recurring-payments.action';
import { CtaButtonSignalService } from '../../../services/cta-button-signal-service/cta-button-signal.service';
import { RecurringPaymentsState } from '../../../state/recurring-payments.state';
import { handleRedirection } from '../cta-redirection.utils';

/**
 * Cancels the mandate the list widget stashed as the current recurring payment, so this button
 * only works on a page reached through the list's Cancel action.
 */
export const pispCancelRecurringPayment = (widgetProperties: BaseWidgetProperties, injector: Injector) => {
  const store = injector.get(Store);
  const alertHandlerService = injector.get(AlertHandlerService);
  const ctaButtonSignalService = injector.get(CtaButtonSignalService);

  const recurringPayment = store.selectSnapshot(RecurringPaymentsState.getCurrentRecurringPayment);

  if (!recurringPayment?.id || !recurringPayment?.accountId) {
    alertHandlerService.showAlertFn('error', 'Select a recurring payment to cancel');
    return;
  }

  const ctaAction = widgetProperties.buttonActionType as string;

  ctaButtonSignalService.setSignal({ [ctaAction]: false });

  store
    .dispatch(
      new PispCancelRecurringPayment({
        accountId: recurringPayment.accountId,
        mandateId: recurringPayment.mandateId,
      }),
    )
    .pipe(take(1))
    .subscribe({
      next: () => {
        ctaButtonSignalService.setSignal({ [ctaAction]: true });
        alertHandlerService.showAlertFn('success', 'Recurring payment cancelled successfully');
        handleRedirection(
          widgetProperties,
          injector,
          ActionButtonOutcomesType.SUCCESS,
          true,
          false,
          ButtonActionType.PISP_CANCEL_RECURRING_PAYMENT,
        );
      },
      error: (error) => {
        console.error('Error cancelling recurring payment:', error);
        ctaButtonSignalService.setSignal({ [ctaAction]: true });
        handleRedirection(
          widgetProperties,
          injector,
          ActionButtonOutcomesType.FAILURE,
          true,
          false,
          ButtonActionType.PISP_CANCEL_RECURRING_PAYMENT,
        );
      },
    });
};
